import DocumentPage from "../../../../invoice/DocumentPage";
import { siiRegularInvoiceConfig } from "./config";

const SIIRegularInvoice = () => (
  <DocumentPage config={siiRegularInvoiceConfig} />
);

export default SIIRegularInvoice;
